import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import Topbar from '../../components/topbar';
import MainSidebar from '../../components/main-sidebar';
import Footer from '../../components/footer';
import PageHeader from '../../components/page-header';
import { Outlet } from 'react-router-dom';
import { useApiServices } from '../../services/api-endpoints/useApiServices';
import { useLoading } from '../../services/redux-services/LoadingContext';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useUser } from '../../services/redux-services/UserInfoContext';
import { ChatProvider, useChat } from '../../services/chat/ChatContext';
import ChatWidget from '../../components/chat/ChatWidget';

function BackendLayoutInner() {
    const { isLoading } = useLoading();
    const api = useApiServices();
    const { setUser } = useUser();
    const { chatUser, setChatUser } = useChat();

    const fetch = async () => {
        const { isSuccess, result } = await api.AuthInfoAsync();
        if (isSuccess) {
            setUser(result);
        }
        await api.GetConfigurationsAsync();
    };

    useEffect(() => {
        fetch();
    }, []);

    useEffect(() => {
        if (isLoading) {
            NProgress.start();
        } else {
            NProgress.done();
        }
    }, [isLoading]);

    const closeSidebar = () => {
        const rootChildren = document.getElementById('root')?.children;
        if (rootChildren) {
            for (let i = 0; i < rootChildren.length; i++) {
                rootChildren[i].classList.remove('nav-collapsed');
            }
        }
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Admin Portal</title>
            </Helmet>

            <Topbar />
            <MainSidebar onClose={closeSidebar} />
            <PageHeader />

            <div className="main-content">
                <Outlet />
                <Footer />
            </div>

            <div className="sidebar-backdrop" onClick={closeSidebar} />

            <ChatWidget
                isOpen={chatUser != null}
                onToggle={() => setChatUser(null)}
                selectedUserId={chatUser}
            />
        </React.Fragment>
    );
}

export default function BackendLayout() {
    return (
        <ChatProvider>
            <BackendLayoutInner />
        </ChatProvider>
    );
}
